import script from "./SmartMatchCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SmartMatchCard.vue?vue&type=script&setup=true&lang=js"

import "./SmartMatchCard.vue?vue&type=style&index=0&id=3a8d5220&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a8d5220"]])

export default __exports__